module.exports = __webpack_public_path__ + "static/qh_3.0f271337.jpg";